import { ShadowCascadesMode } from "./ShadowCascadesMode";
import { Light, LightType } from "./Light";
import { Vector3 } from "../../../maths/Vector3";
import { Laya3DRender } from "../../RenderObjs/Laya3DRender";
export class DirectionLightCom extends Light {
    get direction() {
        return this._direction;
    }
    set direction(value) {
        value.cloneTo(this.direction);
        this._dataModule.setDirection(this._direction);
    }
    ;
    get shadowCascadesMode() {
        return this._dataModule.shadowCascadesMode;
    }
    set shadowCascadesMode(value) {
        this._dataModule.shadowCascadesMode = value;
    }
    get shadowTwoCascadeSplits() {
        return this._dataModule.shadowTwoCascadeSplits;
    }
    set shadowTwoCascadeSplits(value) {
        this._dataModule.shadowTwoCascadeSplits = value;
    }
    get shadowFourCascadeSplits() {
        return this._shadowFourCascadeSplits;
    }
    set shadowFourCascadeSplits(value) {
        if (value.x > value.y || value.y > value.z || value.z > 1.0)
            throw "DiretionLight:Invalid value.";
        value.cloneTo(this._shadowFourCascadeSplits);
        this._dataModule.setShadowFourCascadeSplits(this._shadowFourCascadeSplits);
    }
    constructor() {
        super();
        this._direction = new Vector3();
        this._shadowTwoCascadeSplits = 1.0 / 3.0;
        this._shadowFourCascadeSplits = new Vector3();
        this._lightType = LightType.Directional;
        this.shadowCascadesMode = ShadowCascadesMode.NoCascades;
        this.shadowFourCascadeSplits = new Vector3(1.0 / 15, 3.0 / 15.0, 7.0 / 15.0);
        this.shadowTwoCascadeSplits = 1.0 / 3.0;
    }
    _creatModuleData() {
        this._dataModule = Laya3DRender.Render3DModuleDataFactory.createDirectLight();
    }
    _addToLightQueue() {
        this.owner.scene._directionLights.add(this);
    }
    _removeFromLightQueue() {
        this.owner.scene._directionLights.remove(this);
    }
}
